import {
  type ISelectInputProps,
  SelectInput,
} from '@framework/form/inputs/SelectInput.tsx';
import { createStaticChipValue } from '@framework/form/inputs/StaticChipValue.tsx';
import type * as React from 'react';
import { type AlboConfigurazioneTipoStatoDTO } from '../../configuration/api/schemas/alboConfigurazioneTipoStatoDTO.ts';
import { StateTag } from '../StateTag.tsx';

export interface IStateSelectInputProps {
  name: string;
  states: AlboConfigurazioneTipoStatoDTO[];
  placement?: ISelectInputProps['placement'];
}

export function RegisterRecordStateSelectInputItem(
  props: IStateSelectInputProps,
) {
  const { name, states, placement } = props;

  // Mappa l'array di stati per creare le opzioni per la Select
  const options = states.map(stato => ({
    value: stato.codice!,
    label: (
      <StateTag
        state={stato.denominazione ?? ''}
        color={stato.colore ?? undefined}
        icon={stato.icona ?? undefined}
      />
    ),
  }));

  return (
    <SelectInput
      size="middle"
      name={name}
      placeholder="Stato..."
      allowClear
      placement={placement}
      options={options}
    />
  );
}

/** `renderValue` per il chip FilterBar: risolve il codice stato nella denominazione. */
export function registerRecordStateChipValue(
  states: AlboConfigurazioneTipoStatoDTO[],
): (value: unknown) => React.ReactNode {
  return createStaticChipValue(
    states.map(stato => ({
      value: stato.codice!,
      label: stato.denominazione ?? '',
    })),
  );
}
